import { useTranslation } from 'react-i18next'
import { RadioOptionPicker } from '../RadioOptionPicker/RadioOptionPicker'
import { Option } from '../types'
import { BenchmarkingAnalysis } from '@/hooks'

export const AnalysisTypeSelect: React.FC<{
    value: BenchmarkingAnalysis
    onChange: (type: BenchmarkingAnalysis) => void
}> = (props) => {
    const { t } = useTranslation('translations')
    const { value, onChange } = props

    const options: Array<Option<BenchmarkingAnalysis>> = [
        {
            value: 'trend',
            label: t('analytics.benchmarking.analysisType.trend.label'),
            subtitle: t('analytics.benchmarking.analysisType.trend.subtitle'),
        },
        {
            value: 'average',
            label: t('analytics.benchmarking.analysisType.average.label'),
            subtitle: t('analytics.benchmarking.analysisType.average.subtitle'),
        },
        {
            value: 'totals',
            label: t('analytics.benchmarking.analysisType.totals.label'),
            subtitle: t('analytics.benchmarking.analysisType.totals.subtitle'),
        },
    ]

    return (
        <RadioOptionPicker
            name="analysis-type"
            label={t('analytics.benchmarking.analysisType.label')}
            value={value}
            options={options}
            onChange={(value: string) => {
                onChange(value as BenchmarkingAnalysis)
            }}
            renderLabel={(option) => {
                return (
                    <div className="flex flex-col">
                        <div className="text-label-small text-regular">
                            {option.label}
                        </div>
                        {option.subtitle && (
                            <div className="text-body-small text-subtle">
                                {option.subtitle}
                            </div>
                        )}
                    </div>
                )
            }}
        />
    )
}
